import { h } from 'preact'
import { Geografi, Parti, isGeografi, toNavType } from '../../../domain'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { Message } from '../../../../lib/intl/Message'

import styles from './Undersider.css'
import { getParentKey, OSLO_KOMMUNE } from '../../shared/geografi'
import { NavLinks } from '../../shared/NavLinks/NavLinks'
import { idFrom } from '../../../api'

type Props = {
  current: Geografi | Parti
  geografi: Geografi[]
}

function isRelatedTo(parent: Geografi) {
  return (child: Geografi) => {
    if (child.type === parent.type) {
      return false
    }

    const parentKey = getParentKey(child)
    return parent.key === parentKey
  }
}

function titleKey(current: Geografi) {
  if (current.key === OSLO_KOMMUNE) {
    return 'undersider-tittel-oslo'
  } else {
    return 'undersider-tittel-' + current.type.toLowerCase()
  }
}

export function Undersider(props: Props) {
  const { current, geografi } = props
  if (!isGeografi(current)) {
    return null
  }
  const underGeografi = geografi.filter(isRelatedTo(current))
  if (underGeografi.length) {
    return (
      <section class={styles.undersider} key={idFrom(current)}>
        <h3>
          <Message id={titleKey(current)} values={{ navn: current.navn }} />
        </h3>
        <NavLinks grunndata={underGeografi} sorter={true} type={toNavType(underGeografi[0])} />
      </section>
    )
  }

  return null
}

export function ConnectedUndersider() {
  const state = useAppState()

  if (isGeografi(state.page.current)) {
    return <Undersider current={state.page.current} geografi={state.grunndata.geografi} />
  }
  return null
}
